export default class ProgramDomain {
    constructor(programResponse) {
        this.id = programResponse.id;
        this.name = programResponse.name;
        this.domain = programResponse.domain;
        this.is_extole_domain = programResponse.is_extole_domain;
        this.share_uri = programResponse.share_uri;
        this.redirect_program_id = programResponse.redirect_program_id;
        this.site_patterns = programResponse.site_patterns;
        this.ssl_certificate = programResponse.ssl_certificate;
        this.ssl_certificate_chain = programResponse.ssl_certificate_chain;
        this.ssl_private_key = programResponse.ssl_private_key;
        this.ssl_generation_policy = programResponse.ssl_generation_policy;
        this.cname_target = programResponse.cname_target;
    }
}
